import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Delete the token from local storage
    localStorage.removeItem('sessionToken');
    // Redirect to the front page
    navigate('/');
  }, [navigate]);

  return null;
};

export default Logout;